import { makeStyles } from '@material-ui/core';

export const useGalleryStyles = makeStyles(() => ({
  mainImage: {
    width: '100%',
    height: '100%',
    objectFit: 'contain',
    cursor: 'pointer'
  },
  mainImageContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 8,
    border: '1px solid #EEF0F2'
  }
}));

export const useBackdropStyles = makeStyles(() => ({
  backdrop: {
    zIndex: 5000,
    backgroundColor: 'rgba(0, 0, 0, 0.9)'
  },
  closeContainer: {
    position: 'absolute',
    top: 10,
    right: 10
  },
  galleryContainer: {
    width: '50vw',
    maxWidth: 800,
    minWidth: 300
  }
}));

export const useSGalleryThumbnailStyles = makeStyles(theme => ({
  container: {
    width: 47,
    height: 47,
    borderRadius: 6,
    margin: theme.spacing(2),
    border: `2px solid ${theme.palette.grey[300]}`,
    cursor: 'pointer',
    overflow: 'hidden'
  },
  thumbnail: {
    width: '100%',
    height: '100%',
    objectFit: 'contain'
  },
  active: {
    borderColor: theme.palette.primary.main
  }
}));
